<div [formGroup]="form">
  <mat-form-field class="form-field">
    @if (hasIcon()) {
      <mat-icon matPrefix [matTooltip]="getToolTipText()">{{ iconName }}</mat-icon>
    }
    <input
      [readonly]="isReadOnly"
      matInput
      type="text"
      [placeholder]="placeHolder"
      [formControlName]="controlName"
      [matAutocomplete]="auto" />
    @if (clearButtonEnabled && hasValue()) {
      <button
        [disabled]="disabled || isReadOnly"
        type="button"
        matSuffix
        mat-icon-button
        attr.aria-label="{{ 'DIALOG.CLEAR' | translate }}"
        (click)="clearText()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
</div>
<mat-autocomplete #auto="matAutocomplete">
  @for (item of autoCompleteItems$ | async; track item) {
    <mat-option [value]="item">
      {{ item }}
    </mat-option>
  }
</mat-autocomplete>
